<!-- <div class="card resignation-card">
    <div class="card-header">
        Employee Resignation Form
    </div>

    <div class="card-body">
        <form #resignationForm="ngForm" (ngSubmit)="onSubmit(resignationForm)">
            <div class="row">
                <div class="col-md-3 text-center mt-3">
                    <img [src]="employee.photo" class="img-thumbnail emp-photo" alt="Employee Photo">
                </div>

                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-4 mb-2">
                            <label>Emp Code</label>
                            <input type="text" class="form-control" [value]="employee.empCode" disabled>
                        </div>

                        <div class="col-md-4 mb-2">
                            <label>Emp Name</label>
                            <input type="text" class="form-control" [value]="employee.empName" disabled>
                        </div>

                        <div class="col-md-4 mb-2">
                            <label>Designation</label>
                            <input type="text" class="form-control" [value]="employee.designation" disabled>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 mb-2">
                            <label>Requested Date</label>
                            <input type="date" class="form-control" [value]="employee.requestedDate" disabled>
                        </div>

                        <div class="col-md-4 mb-2">
                            <label>Notice Period</label>
                            <input type="text" class="form-control" [value]="employee.noticePeriod" disabled>
                        </div>

                        <div class="col-md-4 mb-2">
                            <label>Last Working Day</label>
                            <input type="date" class="form-control" [value]="employee.lastWorkingDay" disabled>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <label>Reporting Manager</label>
                            <input type="text" class="form-control" [value]="employee.reportingManager" disabled>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div class="row">
                <div class="col-md-4 mb-2">
                    <label>Proposed Last Working Day</label>
                    <input type="date" class="form-control" name="proposedLastWorkingDay"
                        [(ngModel)]="resignation.proposedLastWorkingDay" required>
                </div>

                <div class="col-md-4 mb-2">
                    <label>Reason for Leaving</label>
                    <select class="form-control" name="reason" [(ngModel)]="resignation.reason" required>
                        <option value="">Select Reason</option>
                        <option>Career Growth</option>
                        <option>Higher Studies</option>
                        <option>Personal Reasons</option>
                        <option>Health Issues</option>
                        <option>Relocation</option>
                    </select>
                </div>

                <div class="col-md-12 mb-2">
                    <label>Remarks</label>
                    <textarea class="form-control" rows="3" name="remark" [(ngModel)]="resignation.remark">
            </textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="submit" class="btn btn-success btn-sm px-4">
                    Submit Resignation
                </button>
            </div>
        </div>
    </div>
</div> -->

<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Resignation Details
    </div>
    <div class="card-body">
        <form #resignationForm="ngForm">

            <div class="row align-items-center user-card mx-1">

                <!-- Image -->
                <div class="col-1 text-center">
                    <img *ngIf="employee.photo" class="userImage" [src]="common.PhotoLink(employee.photo)" />

                    <div *ngIf="!employee.photo" class="initial-image">
                        <div class="image">
                            {{ employee.empName.charAt(0) }}
                        </div>
                    </div>
                </div>

                <!-- Details -->
                <div class="col-9 userdetail d-flex flex-column justify-content-center">
                    <span class="emp-name mb-1">{{ employee.empName }}</span>
                    <span class="emp-code mb-1">#{{ employee.empCode }}</span>
                    <span class="emp-designation">{{ employee.designation }}</span>
                </div>

                <div *ngIf="employee.employeeSeparationRequestId > 0" class="col-2">
                    <span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(employee.approvalStatus) == 'approved', 'warning':common.ToLowerCase(employee.approvalStatus) == 'pending','danger':common.ToLowerCase(employee.approvalStatus) == 'rejected'}">{{employee.approvalStatus}}</span>
                </div>

            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="p-3">
                        <!-- Employee Details -->
                        <div class="row mb-1">
                            <div class="col-md-4">
                                <label>Requested Date</label>
                                <input name="requesteddate" type="text" class="form-control"
                                    [(ngModel)]="employee.requestedDate" disabled>
                                <!-- <div class="value">{{employee.requestedDate}}</div>     -->
                            </div>

                            <div class="col-md-4">
                                <label>Notice Period</label>
                                <input name="noticeperiod" type="text" class="form-control"
                                    [(ngModel)]="employee.noticePeriod" disabled>
                                <!-- <div class="value">{{employee.noticePeriod}}</div> -->
                            </div>

                            <div class="col-md-4 mb-2">
                                <label>Last Working Day</label>
                                <input name="lastworkingday" type="text" class="form-control"
                                    [(value)]="employee.lastWorkingDay" disabled>
                            </div>

                        </div>

                        <!-- Form Fields -->
                        <div class="row">
                            <div class="col-md-4">
                                <label>Reporting Manager</label>
                                <input name="reportingmanager" type="text" class="form-control"
                                    [(ngModel)]="employee.reportingManager" disabled>
                                <!-- <div class="value">{{employee.reportingManager}}</div> -->
                            </div>

                            <div class="col-md-4 mb-2">
                                <label>Proposed Last Working Day</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="dd-mm-yyyy" name="proposedLastWorkingDay"
                                        [(ngModel)]="form.proposedLastWorkingDay" ngbDatepicker
                                        #proposedLastWorkingDay="ngbDatepicker" />
                                    <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                                        (click)="proposedLastWorkingDay.toggle()"></button>
                                </div>
                            </div>

                            <div class="col-md-4 mb-2">
                                <label>Reason for Leaving <span class="text-danger">*</span></label>
                                <ng-select name="reason" [items]="ReasonLoad" bindLabel="SeparationReason"
                                    bindValue="ESS_SeparationReasonId" [(ngModel)]="form.reason" placeholder="Select Reason"
                                    required>
                                </ng-select>
                            </div>

                            <div class="col-md-12 mb-2">
                                <label>Remarks</label>
                                <textarea placeholder="Remark" class="form-control" rows="2" name="remark"
                                    [(ngModel)]="form.remark">
          </textarea>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </form>
    </div>

    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button [routerLink]="['/resign']" class="btn btn-primary">
                    Cancel <i class="bi bi-x-circle ms-2"></i>
                </button>
            </div>
            <div *ngIf="common.ToLowerCase(employee.approvalStatus) == 'pending'" class="col-auto">
                <button (click)="SaveRequest('WITHDRAWN')" class="btn btn-warning">
                    Withdraw <i class="bi bi-x-circle ms-2"></i>
                </button>
            </div>
            <div class="col-auto">
                <button (click)="onSubmit(resignationForm)" class="btn btn-danger">
                    Resign <i class="bi bi-box-arrow-right ms-2"></i>
                </button>
            </div>
        </div>
    </div>
</div>